export class LoadAccountProvincesFromApi {
    public static readonly type: string = '[Accounts API] Load provinces';
}
